import { Checkbox } from "@mui/material";
import { Button, Icon } from "components";
import { TableCell, TableRow } from "components/atoms/BasicTable";
import React, { useId, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setPreviousRoute } from "store/slices/ui.slice";
import { getBalance } from "store/slices/user.slice";
import { LeadProfileDTO } from "utils/dtos/leadDTO";
import EntryFormatter from "utils/EntryFormatter";
import { toastHelper } from "utils/helper";

import { messages } from "utils/message";
import { getEmailBest, getPhoneBest } from "utils/workWithData";
interface PulseRowProps extends LeadProfileDTO {
  id: string;
  currentParams: string;
  selectedRows: string[];
  isLoading?: boolean;
  unselectedIds: string[];
  isAllSelected: boolean;
  scoreBehavior?: number;
  scoreIcp?: number;
  handleSelectRow: (id: string) => void;
  handleUnselectRow: (id: string) => void;
  handleRevealContactByID: (leadId: string) => Promise<void>;
}
export const PulseRow: React.FC<PulseRowProps> = (row) => {
  const {
    currentParams,
    id,
    selectedRows,
    unselectedIds,
    isAllSelected,
    handleSelectRow,
    handleUnselectRow,
    handleRevealContactByID,
  } = row;
  const dispatch = useAppDispatch();
  const [isRevealLoading, setRevealLoading] = useState(false);
  const prepareUrlAndSavePreviousRoute = (
    id: string,
    currentParams: string
  ) => {
    dispatch(setPreviousRoute(location.pathname));
    return id ? `/lead/${id}?${currentParams}` : "";
  };

  const urlPrepared = prepareUrlAndSavePreviousRoute(id, currentParams);
  const isAllListSelected = isAllSelected;
  const isSelected = selectedRows.includes(row.leadId) || isAllListSelected;
  const isUnselected = unselectedIds.includes(row.leadId);
  const contactsRevealeds = useAppSelector(
    (state) => state.data.contactsRevealed
  );

  const isChecked = isAllListSelected ? !isUnselected : isSelected;

  const toastId = useId();

  const getRevealedContact = contactsRevealeds.find((item) => item.id === id);

  const wasRevealed = !!getRevealedContact?.data;

  const rowToRender = {
    ...row,
    ...(wasRevealed ? getRevealedContact.data : {}),
    hideContactInfo: row.hideContactInfo && !wasRevealed,
  };

  return (
    <TableRow className={`hover:bg-gray-700 ${isChecked && "bg-paper-400"}`}>
      <TableCell link={{ to: urlPrepared }} classNameComponent="px-2">
        <Checkbox
          onClick={(event) => {
            event.stopPropagation();
            if (isAllListSelected) {
              handleUnselectRow(rowToRender.leadId);
              return;
            }
            handleSelectRow(rowToRender.leadId);
          }}
          checked={isChecked}
          sx={{
            color: "var(--color-gray-600)",
            "&.Mui-checked": { color: "var(--color-primary-500)" },
            "&:hover": { backgroundColor: "transparent" },
          }}
        />
      </TableCell>

      <TableCell link={{ to: urlPrepared }} className="truncate max-w-[160px]">
        {rowToRender.nameFirst}
      </TableCell>
      <TableCell link={{ to: urlPrepared }} className="truncate">
        {EntryFormatter.formatJobTitle(rowToRender.jobCurrent.title)}
      </TableCell>
      <TableCell link={{ to: urlPrepared }} className="truncate">
        {rowToRender.organization?.name ?? "-"}
      </TableCell>
      {!rowToRender.hideContactInfo ? (
        <>
          <TableCell
            link={{ to: urlPrepared }}
            className={`!text-left  font-semibold`}
          >
            {getEmailBest(rowToRender) ? (
              <div className="!text-greenlight-300 text-xs flex flex-row gap-3 rounded-md p-2 px-3 w-fit bg-greendark-500">
                <Icon name="email" size={14} />
                {getEmailBest(rowToRender)}
              </div>
            ) : (
              "-"
            )}
          </TableCell>
          <TableCell
            link={{ to: urlPrepared }}
            className={`!text-left  font-semibold`}
          >
            {getEmailBest(rowToRender) ? (
              <div className="!text-greenlight-300 text-xs flex flex-row gap-3 rounded-md p-2 px-3 w-fit bg-greendark-500">
                <Icon name="phone" size={14} />
                {getPhoneBest(rowToRender)}
              </div>
            ) : (
              "-"
            )}
          </TableCell>
        </>
      ) : (
        <TableCell colspan={2} link={{ to: urlPrepared }}>
          <div className="flex justify-center w-full items-center">
            <Button
              iconName="credits"
              iconSize={15}
              size="xs"
              isProcessing={getRevealedContact?.isLoading}
              onClick={async (e: any) => {
                e.preventDefault();
                e.stopPropagation();
                setRevealLoading(true);

                toastHelper({
                  toastId,
                  message: "Revealing contact",
                  type: "info",
                });

                try {
                  await handleRevealContactByID(rowToRender.leadId);
                  toastHelper({
                    toastId,
                    message: messages.ENRICHMENT_CONTACTREVEAL_SUCCESS,
                    type: "success",
                  });
                } catch (error) {
                  console.error(error);
                  toastHelper({
                    toastId,
                    message:
                      "Failed to reveal contact. Please try again later.",
                    type: "error",
                  });
                } finally {
                  dispatch(getBalance());
                  setRevealLoading(false);
                }
              }}
            >
              Reveal Contact
            </Button>
          </div>
        </TableCell>
      )}
    </TableRow>
  );
};
